import { render, staticRenderFns } from "./MedicationHomeBasedList.vue?vue&type=template&id=41871183"
import script from "./MedicationHomeBasedList.vue?vue&type=script&lang=js"
export * from "./MedicationHomeBasedList.vue?vue&type=script&lang=js"
import style0 from "./MedicationHomeBasedList.vue?vue&type=style&index=0&id=41871183&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports